import React from "react";

/**
 * KlaroWordmark — the canonical Klaro brand wordmark.
 *
 * Usage:
 *   <KlaroWordmark />                   light background (default)
 *   <KlaroWordmark theme="dark" />      on deep-blue / dark surfaces
 *   <KlaroWordmark size="lg" />         larger variant
 *   <KlaroWordmark size="sm" />         smaller inline variant
 *
 * Never hard-code the word "Klaro" with custom styles elsewhere —
 * always use this component so the brand stays consistent.
 */
const sizeMap = {
  sm:  { fontSize: "1.125rem", letterSpacing: "-0.01em" },
  base:{ fontSize: "1.5rem",   letterSpacing: "-0.02em" },
  lg:  { fontSize: "2rem",     letterSpacing: "-0.02em" },
  xl:  { fontSize: "2.75rem",  letterSpacing: "-0.03em" },
};

export const KlaroWordmark = ({ size = "base", theme = "light", className = "", style = {} }) => {
  const { fontSize, letterSpacing } = sizeMap[size] || sizeMap.base;
  const color = theme === "dark" ? "hsl(var(--primary-foreground))" : "hsl(var(--klaro-deep-blue))";

  return (
    <span
      className={className}
      style={{
        fontFamily: "'Inter', Arial, sans-serif",
        fontWeight: 600,
        fontSize,
        letterSpacing,
        lineHeight: 1,
        color,
        display: "inline-block",
        ...style,
      }}
    >
      Klaro
    </span>
  );
};

export default KlaroWordmark;
